import React from 'react';
import { Link } from 'react-router-dom'
import HomeRef from '../../common/HomeRef';
import { RIGHT_SVG } from '../../staticTypes';
import { trackSharePop } from '../../../Utils/blogs'

const ChReferral = (props) => {
	const { email, visitorId } = props;
	const { referralsCompleted, emailShareUrl, facebookShareUrl, insShareUrl, shareLink } = props.data;
	const onReferralPage = () => {
		trackSharePop(email, visitorId, 'referral-page')
	}
	return (
		<div className="referrals-summary-card">
			<div className="card-list-container no-border">
				<div className="card-list-item-container no-image">
					<Link to="/referral" onClick={onReferralPage}>
						<button className="card-list-item " aria-label="Refer your friends">
							<div className="card-list-item-content">
								<div className="list-item-text-wrapper">
									<div className="list-item-title">Refer your friends</div>
									<div className="list-item-subtitle text-muted">{referralsCompleted} referrals completed</div>
								</div>
							</div>
							<div className="chevron right">
								{RIGHT_SVG}
							</div>
						</button>
					</Link>
				</div>
			</div>
			<div className="card-description">Share this URL to give your friends the reward $15 off coupon</div>
			<HomeRef emailShareUrl={emailShareUrl} facebookShareUrl={facebookShareUrl} insShareUrl={insShareUrl} shareLink={shareLink} email={email} visitorId={visitorId} />

		</div>
	);
}

export default ChReferral;